export const create = {
  createSuccessfully: 'Create new detergent successfully!',
  createFailed: 'Create new detergent failed!',
}
